"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getServerURL = void 0;
/* eslint-disable import/prefer-default-export */

var getServerURL = function getServerURL() {
  // Returns the backend server URL, always with a slash at the end
  var url = process.env.SERVER_URL || process.env.STORYBOOK_SERVER_URL || '';

  if (!url.endsWith('/')) {
    url += '/';
  }

  return url;
};

exports.getServerURL = getServerURL;